module.exports = require('./helpers/bundle-url').getBundleURL('hRXdN') + "ps-bluetarp--dataset-cover.f5cbb2b5.jpg";